module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.params.id != 'me') ? _c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Profil")])]) : _vm._e(), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "item"
  }, [_c('dp', {
    attrs: {
      "who": _vm.who
    }
  }), _vm._v(" "), (_vm.who.id == _vm.user.id) ? _c('header', [_c('h3', [_vm._v("\n                    " + _vm._s(_vm._f("name")(_vm.who)) + "\n                    " + _vm._s(_vm.who.firstname.toLowerCase() != _vm.who.username.toLowerCase() ? ("aka " + (_vm.who.username)) : '') + "\n                ")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn-secondary",
    attrs: {
      "to": "/profile/edit"
    }
  }, [_vm._v("Bearbeiten")])], 1)]) : _c('h3', [_vm._v(_vm._s(_vm._f("name")(_vm.who)))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.byline))])], 1)]), _vm._v(" "), (_vm.who.id != _vm.user.id) ? _c('section', [_c('friendship-button', {
    attrs: {
      "who": _vm.who
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('header', [_c('h2', [_vm._v("Statistik")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn-primary",
    attrs: {
      "to": ("/profile/" + (_vm.$route.params.id) + "/stats")
    }
  }, [_vm._v("Mehr")])], 1)]), _vm._v(" "), _c('elo-chart', {
    attrs: {
      "matches": _vm.matches,
      "userId": _vm.who.id
    }
  })], 1), _vm._v(" "), _c('section', [_c('header', [_c('h2', [_vm._v("Freunde")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn-primary",
    attrs: {
      "to": ("/profile/" + (_vm.$route.params.id) + "/friends")
    }
  }, [_vm._v("Mehr")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dp-list"
  }, _vm._l((_vm.who.friends), function(friend) {
    return _c('div', {
      staticClass: "dp-item"
    }, [_c('dp', {
      attrs: {
        "who": friend
      }
    })], 1)
  }))]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v("ELO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.who.elo))])]), _vm._v(" "), (_vm.who.motto) ? _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v("Spielmotto")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.who.motto))])]) : _vm._e(), _vm._v(" "), (_vm.who.racket) ? _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v("Racket")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.who.racket))])]) : _vm._e(), _vm._v(" "), (_vm.who.school) ? _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v("Schulhaus")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.who.school.name))])]) : _vm._e()]), _vm._v(" "), _c('section', [_c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("\n            Ausloggen\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fc1065b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile.vue
// module id = 227
// module chunks = 0